module.exports = __webpack_public_path__ + "img/49.d8fdc497.webp";